import { GraphQLClient } from 'graphql-request'

const VITE_HASURA_GRAPHQL_ENDPOINT = `${import.meta.env.VITE_HASURA_GRAPHQL_ENDPOINT}/v1/graphql`

const graphQLClient = new GraphQLClient(VITE_HASURA_GRAPHQL_ENDPOINT, {})

export default graphQLClient
